import { Component } from '@angular/core';
import { Voucher } from './voucher.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.css'],
})
export class AnalyticsVouchersComponent extends SuperClass {
  vouchers: any;
  selectedRow: Voucher;
  newAccount: Voucher;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;
  downloadLimits: any[] = [];
  downloadSpeedLimits: any[] = [];
  timeLimits: any[] = [];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Vouchers',
        routerLink: [{ outlets: { sub: [RouterConst.ANALYTICS_VOUCHERS] } }],
      },
    ]);
    this.newAccount = new Voucher();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllVouchers((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.vouchers = data.payload;
      }
    });
    this.http_getTimeLimits('voucher', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const limit = {};
          limit['label'] = element;
          limit['value'] = element;
          this.timeLimits.push(limit);
        });
      }
    });
    this.http_getDownloadLimits('voucher', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const limit = {};
          limit['label'] = element;
          limit['value'] = element;
          this.downloadLimits.push(limit);
        });
      }
    });
    this.http_getSpeedLimits('voucher', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const limit = {};
          limit['label'] = element;
          limit['value'] = element;
          this.downloadSpeedLimits.push(limit);
        });
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      timeLimitValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      timeLimitUnitType: new FormControl('', Validators.required),
      downloadValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downloadUnitType: new FormControl('', Validators.required),
      downSpeedValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downSpeedUnitType: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      size: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      timeLimitValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      timeLimitUnitType: new FormControl('', Validators.required),
      downloadValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downloadUnitType: new FormControl('', Validators.required),
      downSpeedValue: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
      downSpeedUnitType: new FormControl('', Validators.required),
      numberOfDevicesAllowed: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
          Validators.min(1),
        ]),
      ),
    });
  }

  selectRow(e) {
    this.selectedRow = new Voucher(e.data);
  }

  saveAccount() {
    this.http_updateVoucher(this.selectedRow, (data: any) => {
      this.showSuccessMessage('Voucher has been updated');
      this.unselectRow();
      this.vouchers = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new Voucher();
  }

  createNewAccount() {
    const reqBody = {
      voucher: {
        batchName: this.newAccount.batchName,
        timeLimitValue: this.newAccount.timeLimitValue,
        timeLimitUnitType: this.newAccount.timeLimitUnitType,
        downloadValue: this.newAccount.downloadValue,
        downloadUnitType: this.newAccount.downloadUnitType,
        downSpeedValue: this.newAccount.downSpeedValue,
        downSpeedUnitType: this.newAccount.downSpeedUnitType,
        numberOfDevicesAllowed: this.newAccount.numberOfDevicesAllowed,
        enabled: this.newAccount.enabled,
      },
      batchSize: this.newAccount.batchSize,
    };

    this.http_createNewVoucher(reqBody, (data: any) => {
      this.showSuccessMessage('Voucher has been created');
      this.unselectRow();
      this.vouchers = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteVoucher(this.selectedRow, (data: any) => {
      this.showSuccessMessage('Voucher has been deleted');
      this.unselectRow();
      this.vouchers = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/vouchers/vouchers.component.ts